import React, { useState } from 'react'
import TWControls from '../controls/TWControls'
import { Form, useForm } from '../controls/useForm'
import RTEComponent from 'screens/locations/contentPages/RTEComponent'

const PostAddPopup = ({ addNote, postGroup }) => {
	const [input, setInput] = useState('')
	const [value, setValue] = useState('public')

	const initialValues = {
		id: 0,
		content: '',
		postGroup: postGroup,
	}

	console.log(`Popup - postGroup: `, postGroup)

	const validate = () => {
		let temp = { ...errors }
		temp.content = values.content ? '' : 'This field is required.'

		setErrors({
			...temp,
		})

		return Object.values(temp).every(x => x === '')
	}

	const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(initialValues, true, validate)

	const submitHandler = e => {
		e.preventDefault()

		values.content = input

		if (validate()) {
			addNote(values, resetForm)
		}
	}

	const handlePostType = event => {
		setValue(event.target.value)
		console.log(`value: `, value)
	}

	return (
		<Form onSubmit={submitHandler}>
			<div className="grid grid-cols-12 gap-4">
				<div className="col-span-12">
					<RTEComponent input={input} setInput={setInput} />
				</div>

				<div className="col-span-12">
					<div className="newLocation__imageHolder">
						<TWControls.Button size="small" type="submit" text="Post" />
					</div>
				</div>
			</div>
		</Form>
	)
}

export default PostAddPopup
